$(function () {
  var index = {
    init: function init() {
      this.video();
      this.swiper();
      this.linkTo();
      this.yuyue()
    },
    video: function video() {
      TCPlayer("videoPlayerA", {
        fileID: "5285890806776622801",
        appID: "1259605108",
        autoplay: false
      });
      TCPlayer("videoPlayerB", {
        fileID: "5285890806631769900",
        appID: "1259605108",
        autoplay: false
      });
    },
    swiper: function swiper() {
      new Swiper('#youhuiSwiper', {
        autoplay: true,
        direction: 'vertical',
        // slidesPerView: 1,
        loop: true
      });
    },
    linkTo: function () {
      function linkToItem(t, m) {
        $(t).click(function () {
          $('html,body').animate({
            scrollTop: $(m).offset().top
          });
        });
      }
      linkToItem(".cg_list:first-child", '.dyk')
      linkToItem(".cg_list:eq(1)", '.jx')
      linkToItem(".cg_list:eq(2)", '.yl')
      linkToItem(".cg_list:eq(3)", '.zh')
      linkToItem(".zixun", '.city_content')
    },
    yuyue: function () {
      $('.dyk_form').listenForm({
        contentName: [{
          search: "?jtppzq",
          name: " web开学季直播表单（百品）"
        }, {
          search: "?360jtppzq",
          name: "web开学季直播表单（3品）"
        }, {
          search: "",
          name: "web开学季直播表单（SEO）"
        }, {
          search: "?tg",
          name: " web开学季直播表单（原生）"
        }],
        submitTarget: '#formBtn',
        cityRequired: true
      });
      new Bselector({
        showSelected: "#courseName",
        inputSelected: ".course-input",
        options: [{
          text: '北京市'
        }, {
          text: '天津市'
        }, {
          text: '上海市'
        }, {
          text: '重庆市'
        }, {
          text: '河北省'
        }, {
          text: '河南省'
        }, {
          text: '广东省'
        }, {
          text: '辽宁省'
        }, {
          text: '湖南省'
        }, {
          text: '四川省'
        }, {
          text: '安徽省'
        }, {
          text: '山东省'
        }, {
          text: '江苏省'
        }, {
          text: '浙江省'
        }, {
          text: '湖北省'
        }, {
          text: '山西省'
        }, {
          text: '陕西省'
        }, {
          text: '福建省'
        }, {
          text: '江西省'
        }, {
          text: '广西省'
        }, {
          text: '甘肃省'
        }, {
          text: '黑龙江省'
        }, {
          text: '内蒙古'
        }, {
          text: '吉林省'
        }, {
          text: '新疆维吾尔'
        }, {
          text: '贵州省'
        }, {
          text: '云南省'
        }, {
          text: '青海省'
        }, {
          text: '西藏'
        }, {
          text: '宁夏回族'
        }, {
          text: '海南省'
        }]
      });
      new Bselector({
        showSelected: "#cityName",
        inputSelected: ".city-btn",
        options: [{
          text: '北京市'
        }, {
          text: '天津市'
        }, {
          text: '上海市'
        }, {
          text: '重庆市'
        }, {
          text: '河北省'
        }, {
          text: '河南省'
        }, {
          text: '广东省'
        }, {
          text: '辽宁省'
        }, {
          text: '湖南省'
        }, {
          text: '四川省'
        }, {
          text: '安徽省'
        }, {
          text: '山东省'
        }, {
          text: '江苏省'
        }, {
          text: '浙江省'
        }, {
          text: '湖北省'
        }, {
          text: '山西省'
        }, {
          text: '陕西省'
        }, {
          text: '福建省'
        }, {
          text: '江西省'
        }, {
          text: '广西省'
        }, {
          text: '甘肃省'
        }, {
          text: '黑龙江省'
        }, {
          text: '内蒙古'
        }, {
          text: '吉林省'
        }, {
          text: '新疆维吾尔'
        }, {
          text: '贵州省'
        }, {
          text: '云南省'
        }, {
          text: '青海省'
        }, {
          text: '西藏'
        }, {
          text: '宁夏回族'
        }, {
          text: '海南省'
        }]
      });
      new Bselector({
        showSelected: "#courseInput",
        inputSelected: ".course-btn",
        options: [{
          text: '雅思'
        }, {
          text: '托福'
        }, {
          text: 'SAT'
        }]
      });
      $('.yuyue').listenForm({
        contentName: [{
          search: "?jtppzq",
          name: " web开学季底部表单（百品）"
        }, {
          search: "?360jtppzq",
          name: "web开学季底部表单（3品）"
        }, {
          search: "",
          name: "web开学季底部表单（SEO）"
        }, {
          search: "?tg",
          name: " web开学季底部表单（原生）"
        }],
        submitTarget: '#yuyueBtn',
        cityRequired: true,
        courseRequired: true
      });


      $(".guanbi").click(function () {
        $(".yuyue").hide();
        setTimeout(function () {
          $('.yuyue').fadeIn();
        }, 10000);
      });
      setTimeout(function () {
        $('.yuyue').fadeIn();
      }, 10000);
    }
  }
  index.init();

})